import { Route, Switch, useLocation } from 'react-router';
import { Tab, TabListWrapper } from 'components/Tab';
import Info from './Info';
import Link from 'components/Link';
import ManagePlan from './ManagePlan';
import ManageSpotlights from './ManageSpotlights';
import PageBar from 'components/PageBar';
import { PagePadding } from 'components/PagePadding';
import { SectionCard } from 'components/SectionCard';
import Tooltips from './Tooltips';

function Admin() {
    const { pathname } = useLocation();
    return (
        <PagePadding className="pt-16">
            <PageBar showCountrySelect={false} />
            <h1>Admin</h1>
            <SectionCard
                $space={0}
                css="padding: 0px; min-height: calc(100vh - 128px);"
            >
                <TabListWrapper>
                    <Tab
                        as={Link}
                        $selected={pathname === '/admin'}
                        to="/admin"
                    >
                        Info
                    </Tab>
                    <Tab
                        as={Link}
                        $selected={pathname === '/admin/plan'}
                        to="/admin/plan"
                    >
                        Plan
                    </Tab>
                    <Tab
                        as={Link}
                        $selected={pathname?.includes('/admin/spotlights')}
                        to="/admin/spotlights"
                    >
                        Spotlights
                    </Tab>
                    <Tab
                        as={Link}
                        $selected={pathname?.includes('/admin/tooltips')}
                        to="/admin/tooltips"
                    >
                        Tooltips
                    </Tab>
                </TabListWrapper>
                <article css="padding: 1.5rem 1rem;">
                    <Switch>
                        <Route path="/admin/plan">
                            <ManagePlan />
                        </Route>
                        <Route path="/admin/spotlights">
                            <ManageSpotlights />
                        </Route>
                        <Route path="/admin/tooltips">
                            <Tooltips />
                        </Route>
                        <Route path="/admin">
                            <Info />
                        </Route>
                    </Switch>
                </article>
            </SectionCard>
        </PagePadding>
    );
}

export default Admin;
